import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q6 = ({ history }) => {
  const { t } = useTranslation();
  const Q6Options = useMemo(
    () => [
      {
        id: 0,
        name: t('yes'),
        value: 'yes',
      },
      {
        id: 1,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question6')}
      options={Q6Options}
      nextUrl="q7"
      screenName="q6"
    />
  );
};

export default Q6;
